import { CodeReviewCommentHistoryModel } from "./code-review-commet-history-model";

export class CodeReviewCommentModel {
    _id: string;
    deleted: number;
    created_by: string;
    created_time: number;
    last_updated_by: string;
    last_updated_time: number;
    comment_type: string;
    code_review_id: string;
    artifact_id: string;
    artifact_type: string;
    artifact_name: string;
    outdated: boolean;
    body: string;
    replies: string[];
    resolution_required: boolean;
    resolved: boolean;
    resolved_by: string;
    parent_comment_id: string;
    technical_details_id: string;
    start_line: number;
    comment_line: number;
    comment_side: string;
    comment_history: CodeReviewCommentHistoryModel[];
}